import { useState } from 'react';
import { cancelMsg, continueMsg, selectCompanyHeaderMsg, selectCompanyMsg, t } from '../../common/i18n/index.js';
import { CompanySelector } from '../../components/CompanySelector/CompanySelector.js';
import { DialogWrapper } from '../../components/DialogWrapper/DialogWrapper.js';
import { getUserAccounts } from '../../components/Header/dynamic/headerFunctions.js';
import { useAuth } from '../../public/site/AuthProvider.js';
import type { DialogWrapperButton } from '../../components/DialogWrapper/DialogWrapper.js';

export interface SelectCompanyDialogProps {
  onCloseDialog: () => void;
  onContinue: (selectedMdmId: string) => void;
}

export const SelectCompanyDialog = ({ onCloseDialog, onContinue }: SelectCompanyDialogProps) => {
  const { authenticatedUser, setActiveAccount } = useAuth();
  const userAccounts = getUserAccounts(authenticatedUser);
  const activeAccount = userAccounts.find(account => account.active);
  const [activeMdmId, setActiveMdmId] = useState(activeAccount?.accountMasterId || '');

  const buttons: DialogWrapperButton[] = [
    {
      color: 'light',
      text: t.B2V1(cancelMsg),
      onClick: () => onCloseDialog(),
    },
    {
      text: t.I62A(continueMsg),
      onClick: () => {
        onContinue(activeMdmId);
      },
    },
  ];
  return (
    <DialogWrapper onCloseDialog={onCloseDialog} buttons={buttons} header={t.BR9A(selectCompanyHeaderMsg)}>
      <CompanySelector
        userAccounts={userAccounts}
        onInputChange={(_, option) => {
          setActiveMdmId(option.accountMasterId!);
          setActiveAccount(option.accountMasterId!);
        }}
        labelText={t.JUY2(selectCompanyMsg)}
        labelWeightNormal
      />
    </DialogWrapper>
  );
};
